import request from "@/utils/request";

// 查看期刊
export function search_journal(data) {
    return request({
        url: "/search_journal",
        method: "post",
        data: data,
    });
}
// 查看分类
export function search_category(data) {
    return request({
        url: "/search_category",
        method: "post",
        data: data,
    });
}
// 删除期刊
export function delete_journal(data) {
    return request({
        url: "/delete_journal",
        method: "post",
        data: data,
    });
}
// 期刊详情
export function journal_particulars(data) {
    return request({
        url: "/journal_particulars",
        method: "post",
        data: data,
    });
}
// 添加期刊图片
export function add_journal_image(data) {
    return request({
        url: "/add_journal_image",
        method: "post",
        data: data,
    });
}
// 添加期刊
export function add_journal(data) {
    return request({
        url: "/add_journal",
        method: "post",
        data: data,
    });
}
// 修改期刊
export function update_journal(data) {
    return request({
        url: "/update_journal",
        method: "post",
        data: data,
    });
}
